import { Link } from "react-router-dom";
import { ArrowUpRight, Bot, MonitorSmartphone, Search, type LucideIcon } from "lucide-react";
import { services, type Service } from "@/data/services";
import { cn } from "@/lib/utils";

const ICONS: Record<Service["svgKey"], LucideIcon> = {
  website: MonitorSmartphone,
  bot: Bot,
  magnify: Search,
};

export interface ServiceFrontsProps {
  /** Default: `services` de `src/data/services.ts`. */
  items?: Service[];
  className?: string;
}

/**
 * "O que eu faço" da home: um card por frente de trabalho, todos com o
 * mesmo peso, cada um levando à página especializada. Não lista escopo
 * nem preço detalhado — isso mora em /servicos e /automacao-empresarial.
 */
export function ServiceFronts({ items = services, className }: ServiceFrontsProps) {
  return (
    <section
      id="frentes"
      className={cn(
        "mx-auto max-w-[1180px] scroll-mt-24 px-8 py-[76px] max-[900px]:px-5",
        className,
      )}
    >
      <h2 className="max-w-[640px] text-[33px] font-bold leading-tight tracking-[-0.03em]">
        Três frentes, um objetivo: o negócio render mais
      </h2>
      <p className="mt-3.5 max-w-[600px] text-base text-muted-foreground">
        Escolha por onde começar. Cada frente tem uma página com escopo, prazo e investimento.
      </p>

      <div className="mt-[38px] grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-[18px]">
        {items.map((s) => {
          const Icon = ICONS[s.svgKey];
          return (
            <Link
              key={s.slug}
              to={s.href}
              className="flex flex-col gap-3.5 rounded-[18px] border border-border bg-card p-[26px] shadow-card transition-[border-color,transform] duration-150 hover:-translate-y-0.5 hover:border-primary"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-accent text-primary">
                  <Icon className="h-5 w-5" aria-hidden />
                </span>
                <ArrowUpRight className="h-[18px] w-[18px] text-primary" aria-hidden />
              </div>
              <h3 className="text-[19px] font-bold leading-[1.3] tracking-[-0.02em]">
                {s.shortTitle}
              </h3>
              <p className="text-sm leading-[1.6] text-muted-foreground">{s.summary}</p>
              <div className="mt-auto border-t border-border pt-3.5 text-sm font-bold">
                {s.offer}
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default ServiceFronts;
